import { DocumentNode, useMutation } from '@apollo/client'
import { DeleteUserPaymentMethod, DeleteUserPaymentMethodVariables } from '../../types'
import { DELETE_PAYMENT_METHOD } from './operations'

interface Props {
  refetchQuery?: DocumentNode
}

export const useDeletePaymentMethod = ({ refetchQuery }: Props = {}) =>
  useMutation<DeleteUserPaymentMethod, DeleteUserPaymentMethodVariables>(DELETE_PAYMENT_METHOD, {
    ...(refetchQuery && {
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: refetchQuery,
        },
      ],
    }),
  })
